module.exports = __webpack_public_path__ + "img/pay_at_table.3303347f.png";